/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'time': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 1.55c5.852 0 10.618 4.671 10.618 10.449S17.852 22.447 12 22.447c-5.853 0-10.618-4.67-10.618-10.448C1.382 6.221 6.147 1.551 12 1.551zm0 1.2c-5.21 0-9.419 4.153-9.42 9.249 0 5.096 4.21 9.249 9.42 9.249s9.418-4.153 9.418-9.249c0-5.096-4.21-9.249-9.418-9.249zm-.17 3.024a.6.6 0 01.6.6v6.871h4.494a.601.601 0 010 1.2H11.83a.6.6 0 01-.6-.6V6.375a.6.6 0 01.6-.6z" _fill="#0077C8"/>'
  }
})
